import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instance3dpz39ekmwtkx as RequestHook_instance,
  TransformRequestBodyHook_instance2rtk49v5zeoj1 as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance11jxsj1c494hm as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.key_1 = key;
        this.client_1 = client;
        this.pluginConfig_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.hooks_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_0 = this;
        tmp_0.onClose_1 = ClientPluginBuilder$onClose$lambda;
      }
      onRequest_fk8bil_k$(block) {
        this.on_z1oiz_k$(RequestHook_instance, block);
      }
      transformRequestBody_immy9t_k$(block) {
        this.on_z1oiz_k$(TransformRequestBodyHook_instance, block);
      }
      transformResponseBody_ee7rr5_k$(block) {
        this.on_z1oiz_k$(TransformResponseBodyHook_instance, block);
      }
      on_z1oiz_k$(hook, handler) {
        this.hooks_1.add_utx5q5_k$(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
